import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

const About = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-dark-950 min-h-screen py-12 relative overflow-hidden">
      {/* Background Effects */}
      <div className="fixed inset-0 bg-grid-pattern opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-mesh opacity-30"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-10"
          >
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              <span className="text-gradient">{t('about.title')}</span>
            </h1>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary-500 to-transparent mx-auto"></div>
          </motion.div>

          <div className="space-y-8">
            <motion.section
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="card-hover"
            >
              <h2 className="text-2xl font-bold mb-4 text-gradient">{t('about.company')}</h2>
              <p className="text-base text-gray-300 leading-relaxed">
                {t('about.companyDesc')}
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="card-hover"
            >
              <h2 className="text-2xl font-bold mb-4 text-gradient">{t('about.vision')}</h2>
              <p className="text-base text-gray-300 leading-relaxed">
                {t('about.visionDesc')}
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="card-hover"
            >
              <h2 className="text-2xl font-bold mb-6 text-gradient">{t('about.services')}</h2>
              <ul className="space-y-3">
                {(t('about.servicesList', { returnObjects: true }) as string[]).map((service, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.6 + index * 0.1, duration: 0.4 }}
                    className="flex items-center gap-3 text-base text-gray-300"
                  >
                    <span className="w-1.5 h-1.5 bg-primary-500 rounded-full flex-shrink-0"></span>
                    {service}
                  </motion.li>
                ))}
              </ul>
            </motion.section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
